package com.appsyde.shared.presentation.screen.component.ticket

/**
 * Normalise une chaîne pour la recherche : minuscules, sans accents.
 */
fun normalizeForSearch(s: String): String =
    s.lowercase()
        .replace('à', 'a').replace('â', 'a').replace('ä', 'a')
        .replace('é', 'e').replace('è', 'e').replace('ê', 'e').replace('ë', 'e')
        .replace('ï', 'i').replace('î', 'i')
        .replace('ô', 'o').replace('ö', 'o').replace('ù', 'u').replace('û', 'u').replace('ü', 'u')
        .replace('ç', 'c').replace('œ', 'o').replace('æ', 'a')

/**
 * Filtre les lignes par requête : mots en OR, recherche dans summary, client, intent, priority, subtitleItems.
 */
fun filterTicketsBySearch(rows: List<TicketRowUi>, query: String): List<TicketRowUi> {
    val q = query.trim()
    if (q.isBlank()) return rows
    val terms = q.split(Regex("\\s+")).map { normalizeForSearch(it) }.filter { it.isNotBlank() }
    if (terms.isEmpty()) return rows
    return rows.filter { row ->
        val normSummary = normalizeForSearch(row.summary)
        val normClient = normalizeForSearch(row.client)
        val normIntent = normalizeForSearch(row.intent)
        val normPriority = normalizeForSearch(row.priority)
        val normSubs = row.subtitleItems.joinToString(" ") { normalizeForSearch(it) }
        val combined = "$normSummary $normClient $normIntent $normPriority $normSubs"
        terms.any { term -> combined.contains(term) }
    }
}
